<template>

  <div>
    <div
      class="dropdown"
      :class="{'box-loading': loading}">
      <button
        class="btn btn-dark btn-sm"
        :class="{ 'dropdown-toggle': !diversityStatus }"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="diversityStatus">
        DE&I {{ status ? `(${status})` : '' }}
        </button>
      <div
        v-if="!diversityStatus"
        class="dropdown-menu"
        aria-labelledby="dropdownMenuButton">
        <button
          class="dropdown-item"
          :disabled="!candidate.email"
          @click="requestDiversity">{{ $t('Request DE&I data') }}</button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'CandidateDiversity',
  components: {
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    candidate () {
      return this.$store.getters.getCandidate
    },
    diversityStatus () {
      return this.candidate.diversity_status
    },
    status () {
      return {'completed': 'Respondido', 'requested': 'Solicitado'}[this.diversityStatus]
    }
  },
  created () {
  },
  methods: {
    requestDiversity () {
      this.loading = true
      this.$store
      .dispatch('requestDiversity', {
        candidate_id: this.candidate._id
      })
      .then((result) => {
        this.loading = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Header/CandidateDiversity.vue